import { render, staticRenderFns } from "./AutoTriggers.vue?vue&type=template&id=80cd7d4c&scoped=true"
import script from "./AutoTriggers.vue?vue&type=script&lang=js"
export * from "./AutoTriggers.vue?vue&type=script&lang=js"
import style0 from "./AutoTriggers.vue?vue&type=style&index=0&id=80cd7d4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80cd7d4c",
  null
  
)

export default component.exports